import fp from 'lodash/fp';

import { getTimeStamp } from '../../../webcommon/common/helpers';

import * as constants from './constants';
import * as actions from './actions';

export const INITIAL_STATE = {
    columns: constants.columns,
    filterDefinitions: constants.filterDefinitions,
    defaultFilters: constants.defaultFilters,
    loading: false,
    initialised: false,
    lastUpdated: getTimeStamp(),
    rows: [],
    loadRequestMappings: [],
    currentServerFilters: [],
    detailsBeingViewed: '',
    gridSorting: constants.defaultGridSorting
};

const setInitialised = fp.set('initialised');
const setLoading = fp.set('loading');
const setDetailsBeingViewed = fp.set('detailsBeingViewed');
const setLoadRequestMappings = fp.set('loadRequestMappings');
const setGridSorting = fp.set('gridSorting');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return setInitialised(action.initialised, state);
        }
        case actions.SET_DETAILS_BEING_VEIWED: {
            return setDetailsBeingViewed(action.details, state);
        }
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_LOAD_REQUEST_MAPPINGS: {
            return setLoadRequestMappings(action.mappings, state);
        }
        case actions.SET_ROWS: {
            return {
                ...state,
                rows: action.rows,
                currentServerFilters: action.serverFilters,
                lastUpdated: getTimeStamp()
            };
        }
        case actions.SET_ROW_CHECKED: {
            return {
                ...state,
                rows: state.rows
                    .map(row => (row.requestId !== action.id ? row
                        : fp.set('selected', action.checked, row)))
            };
        }
        case actions.SET_ALL_ROWS_CHECKED: {
            return {
                ...state,
                rows: state.rows
                    .map(row => fp.set('selected', action.checked, row))
            };
        }
        case actions.SET_GRID_SORTS: {
            const alreadyExists = state.gridSorting.find(sort => sort.gridId === action.gridId);
            if (!alreadyExists) {
                return {
                    ...state,
                    gridSorting: state.gridSorting.concat({
                        gridId: action.gridId,
                        gridSort: action.sorting
                    })
                };
            }

            return {
                ...state,
                gridSorting: state.gridSorting.map(
                    sort => (sort.gridId === action.gridId ? fp.set('gridSort', action.sorting, sort) : sort)
                )
            };
        }
        case actions.SET_ALL_GRID_SORTS: {
            return setGridSorting(action.data, state);
        }
        default:
            return state;
    }
}
